"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderedIdenticonBase64 = void 0;
/* eslint-disable */
const Identicon = require('identicon.js');
const { fonts, renderPixels } = require('js-pixel-fonts');
// any is used here since a library without typings is used (identicon.js).
// However, all functions that involved `any` are used internally (without export).
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const identiconPNGtoBase64 = (pngObj) => {
    return `data:image/png;base64,${pngObj.getBase64()}`;
};
// any is used here since a library without typings is used (identicon.js).
// However, all functions that involved `any` are used internally (without export).
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const paintPixel = (pngObj, x, y, color) => {
    pngObj.buffer[pngObj.index(x + 1, y)] = pngObj.color(...color);
};
const getRenderedIdenticonPNG = (tokenId, text, options
// any is used here since a library without typings is used (identicon.js).
// However, all functions that involved `any` are used internally (without export).
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const identiconOptions = {
        identiconImage: {
            size: ((_a = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _a === void 0 ? void 0 : _a.size) || 128,
            margin: ((_b = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _b === void 0 ? void 0 : _b.margin) || 0.08,
            foreground: (_c = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _c === void 0 ? void 0 : _c.foreground,
            background: ((_d = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _d === void 0 ? void 0 : _d.background) || [240, 240, 240, 255],
            saturation: ((_e = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _e === void 0 ? void 0 : _e.saturation) || 0.7,
            brightness: ((_f = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _f === void 0 ? void 0 : _f.brightness) || 0.5,
            format: 'png'
        },
        identiconText: {
            textColor: ((_g = options === null || options === void 0 ? void 0 : options.identiconText) === null || _g === void 0 ? void 0 : _g.textColor) || [255, 255, 255, 255],
            // if no provided `symbolScale`, then `symbolScale` is automatically computed given image size and text length
            symbolScale: ((_h = options === null || options === void 0 ? void 0 : options.identiconText) === null || _h === void 0 ? void 0 : _h.symbolScale) ||
                Math.floor((((_j = options === null || options === void 0 ? void 0 : options.identiconImage) === null || _j === void 0 ? void 0 : _j.size) || 128) / (6 * ((text === null || text === void 0 ? void 0 : text.length) || 3))),
            enableShadow: ((_k = options === null || options === void 0 ? void 0 : options.identiconText) === null || _k === void 0 ? void 0 : _k.enableShadow) || false,
            shadowColor: ((_l = options === null || options === void 0 ? void 0 : options.identiconText) === null || _l === void 0 ? void 0 : _l.shadowColor) || [0, 0, 0, 255]
        }
    };
    // In order to additionally render text, we acquire PNGLib object here which has some convenient png operator.
    // https://github.com/stewartlord/identicon.js/blob/master/pnglib.js
    const identiconImage = new Identicon(tokenId === null || tokenId === void 0 ? void 0 : tokenId.substring(2), identiconOptions.identiconImage).render();
    // we just return if no symbol
    if (!text)
        return identiconImage;
    if (text.length === 0)
        return identiconImage;
    // here we start to render the text
    const symbolPixels = renderPixels(text, fonts.sevenPlus);
    // get fonts width and height
    // `pixelSymbolWidth` and `pixelSymbolHeight` are the original width and height of pixel fonts
    // generated by 'js-pixel-fonts'. They can't be modified.
    const pixelSymbolWidth = symbolPixels[0].length, // here `symbolPixels` is guaranteed to have at least one child.
    pixelSymbolHeight = symbolPixels.length;
    // calculate the offset in order for centering the text
    const offsetX = Math.round((identiconOptions.identiconImage.size -
        pixelSymbolWidth * identiconOptions.identiconText.symbolScale) /
        2);
    const offsetY = Math.round((identiconOptions.identiconImage.size -
        pixelSymbolHeight * identiconOptions.identiconText.symbolScale) /
        2);
    // render pixel text
    for (let x = 0; x < identiconOptions.identiconImage.size; x++) {
        const offsettedX = Math.floor((x - offsetX) / identiconOptions.identiconText.symbolScale);
        if (offsettedX < 0 || offsettedX >= pixelSymbolWidth)
            continue;
        for (let y = 0; y < identiconOptions.identiconImage.size; y++) {
            const offsettedY = Math.floor((y - offsetY) / identiconOptions.identiconText.symbolScale);
            if (offsettedY < 0 || offsettedY >= pixelSymbolHeight)
                continue;
            if (symbolPixels[offsettedY][offsettedX]) {
                // make the pixel at current position white (RGBA: 255, 255, 255, 255)
                paintPixel(identiconImage, x, y, identiconOptions.identiconText.textColor);
                if (identiconOptions.identiconText.enableShadow) {
                    // create shadow
                    paintPixel(identiconImage, x + 1, y + 1, identiconOptions.identiconText.shadowColor);
                }
            }
        }
    }
    return identiconImage;
};
const getRenderedIdenticonBase64 = (tokenId, text, options) => {
    return identiconPNGtoBase64(getRenderedIdenticonPNG(tokenId, text, options));
};
exports.getRenderedIdenticonBase64 = getRenderedIdenticonBase64;
